<div class="pt-2 pb-3">
  <section class="mt-1 mb-3 rounded m-auto w-100" id="section" >
    <form [formGroup]="composedEditForm">

      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{'pass.name' | translate}}</mat-label>
        <input formControlName="name" type="text" matInput placeholder="{{'pass.name' | translate}}">
      </mat-form-field>

      <div class="d-flex flex-row">
        <div class="pe-2 flex-grow-1">
          <div class="input-group">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{'pass.title' | translate}}</mat-label>
              <input formControlName="title" type="text" matInput placeholder="{{'pass.title' | translate}}">
            </mat-form-field>
          </div>
        </div>
        <div class="ps-2 flex-grow-1">
          <div class="input-group">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{'pass.subtitle' | translate}}</mat-label>
              <input formControlName="subtitle" type="text" matInput placeholder="{{'pass.subtitle' | translate}}">
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="d-flex flex-row justify-content-between align-items-center">
        <span class="text-muted">{{'pass.composed.content' | translate}}</span>

        <div class="d-flex flex-row justify-content-between align-items-center">
          <button mat-button class="secondary-gray-button my-3" id="btn-add" (click)="deleteAllContent()" [disabled]="allproperties?.length == 0 || translationMode">
            <mat-icon>close</mat-icon> {{'delete' | translate}}
          </button>

          <button mat-button class="secondary-gray-button my-1 ms-2" id="btn-add-composed" [matMenuTriggerFor]="composedTypesNodeAdd" [disabled]="translationMode">
            <mat-icon>add_circle</mat-icon> {{'add' | translate}}
          </button>
        </div>

        <mat-menu #composedTypesNodeAdd="matMenu">
          @for (composed of composedOptions; track composed; let index = $index) {
            <button mat-menu-item (click)="addContentNode(composed);" [disabled]="translationMode">
              <mat-icon>{{composed.icon}}</mat-icon>{{composed.translate | translate}}
            </button>
          }
        </mat-menu>
      </div>
      <mat-card class="mb-4">
        <mat-card-content>

          <div class="p-2">
            @if (allproperties?.length==0) {
              <div>{{'empty' | translate}}</div>
            }

            <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="example-tree">
              <!-- This is the tree node template for leaf nodes -->
              <!-- There is inline padding applied to this node using styles. This padding value depends on the mat-icon-button width. -->
              <mat-tree-node *matTreeNodeDef="let node; let index = index" matTreeNodeToggle class=" border-bottom" >
                <div class="w-100 d-flex justify-content-between align-items-center">
                  <div class="d-flex flex-row justify-content-start flex-nowrap align-items-center w-75" (click)="editNodeAttributes(node, index)">
                    @if (node.type=='text') {
                      <mat-icon style="color:var(--warmOrange);">text_format</mat-icon>
                    }
                    @if (node.type=='image') {
                      <mat-icon style="color:var(--warmOrange);">image</mat-icon>
                    }
                    @if (node.type=='hstack') {
                      <mat-icon style="color:var(--warmOrange);">view_column</mat-icon>
                    }
                    @if (node.type=='vstack') {
                      <mat-icon style="color:var(--warmOrange);">table_rows</mat-icon>
                    }
                    @if (node.type=='zstack') {
                      <mat-icon style="color:var(--warmOrange);">desktop_landscape</mat-icon>
                    }
                    @if (node.type=='circle') {
                      <mat-icon style="color:var(--warmOrange);">circle</mat-icon>
                    }
                    @if (node.type=='rectangle') {
                      <mat-icon style="color:var(--warmOrange);">rectangle</mat-icon>
                    }

                    @if (node.type=='text') {
                      <span class="p-1 text-truncate w-75" style="color:black;" >{{node?.attributes?.text ? node?.attributes?.text : '""' }}</span>
                    }
                    @if (node.type=='image') {
                      <span class="p-1 text-truncate w-75" style="color:black;" >{{node?.attributes?.url ? node?.attributes?.url : '""' }}</span>
                    }
                    @if (node.type=='hstack') {
                      <span class="p-1" style="color:black;" >H-Stack</span>
                    }
                    @if (node.type=='vstack') {
                      <span class="p-1" style="color:black;" >V-Stack</span>
                    }
                    @if (node.type=='zstack') {
                      <span class="p-1" style="color:black;" >Z-Stack</span>
                    }
                    @if (node.type=='circle') {
                      <span class="p-1" style="color:black;" >Circle</span>
                    }
                    @if (node.type=='rectangle') {
                      <span class="p-1" style="color:black;" >Rectangle</span>
                    }

                  </div>

                  <button mat-icon-button (click)="deleteThisNode(node)" [disabled]="translationMode"><mat-icon>delete</mat-icon></button>
                </div>
              </mat-tree-node>
              <!-- This is the tree node template for expandable nodes -->
              <mat-nested-tree-node *matTreeNodeDef="let node;let index = index; when: hasChild" class=" border-bottom" >
                <div class="mat-tree-node border-bottom">
                  <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name">
                    <mat-icon class="mat-icon-rtl-mirror"> {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}} </mat-icon>
                  </button>
                  <div class="d-flex flex-row justify-content-between flex-nowrap align-items-center w-100">
                    <div class="d-flex flex-row justify-content-start flex-nowrap align-items-center w-100">
                      @if (node.type=='text') {
                        <mat-icon style="color:var(--warmOrange);">text_format</mat-icon>
                      }
                      @if (node.type=='image') {
                        <mat-icon style="color:var(--warmOrange);">image</mat-icon>
                      }
                      @if (node.type=='hstack') {
                        <mat-icon style="color:var(--warmOrange);">view_column</mat-icon>
                      }
                      @if (node.type=='vstack') {
                        <mat-icon style="color:var(--warmOrange);">table_rows</mat-icon>
                      }
                      @if (node.type=='zstack') {
                        <mat-icon style="color:var(--warmOrange);">desktop_landscape</mat-icon>
                      }
                      @if (node.type=='circle') {
                        <mat-icon style="color:var(--warmOrange);">circle</mat-icon>
                      }
                      @if (node.type=='rectangle') {
                        <mat-icon style="color:var(--warmOrange);">rectangle</mat-icon>
                      }

                      @if (node.type=='text') {
                        <span class="p-1 text-truncate w-75" style="color:black;" >{{node?.attributes?.text ? node?.attributes?.text : '""' }}</span>
                      }
                      @if (node.type=='image') {
                        <span class="p-1 text-truncate w-75" style="color:black;" >{{node?.attributes?.url ? node?.attributes?.url : '""' }}</span>
                      }
                      @if (node.type=='hstack') {
                        <span class="p-1" style="color:black;" >H-Stack</span>
                      }
                      @if (node.type=='vstack') {
                        <span class="p-1" style="color:black;" >V-Stack</span>
                      }
                      @if (node.type=='zstack') {
                        <span class="p-1" style="color:black;" >Z-Stack</span>
                      }
                      @if (node.type=='circle') {
                        <span class="p-1" style="color:black;" >Circle</span>
                      }
                      @if (node.type=='rectangle') {
                        <span class="p-1" style="color:black;" >Rectangle</span>
                      }
                    </div>
                    <button mat-icon-button id="btn-edit-node-composed" (click)="editNodeAttributes(node, index)" [disabled]="translationModeOriginal">
                      <mat-icon >edit</mat-icon>
                    </button>

                    <button mat-icon-button id="btn-delete-node-composed" (click)="deleteThisNode(node)" [disabled]="translationMode"><mat-icon>delete</mat-icon></button>

                    <button mat-icon-button id="btn-add-node-composed" [matMenuTriggerFor]="composedTypesNode" [disabled]="translationMode">
                      <mat-icon >add_circle</mat-icon>
                    </button>
                  </div>

                  <mat-menu #composedTypesNode="matMenu">
                    @for (composed of composedOptions; track composed; let index = $index) {
                      <button mat-menu-item (click)="addChildrenNode(node, composed);" [disabled]="translationMode">
                        <mat-icon>{{composed.icon}}</mat-icon>{{composed.translate | translate}} </button>
                      }
                    </mat-menu>
                  </div>
                  <!-- There is inline padding applied to this div using styles.
                  This padding value depends on the mat-icon-button width.  -->
                  <div [class.example-tree-invisible]="!treeControl.isExpanded(node)" role="group">
                    <ng-container matTreeNodeOutlet></ng-container>
                  </div>
                </mat-nested-tree-node>
              </mat-tree>

            </div>

          </mat-card-content>
        </mat-card>

        <div [app-widget-styling] = "{'form':composedEditForm.value, 'widgetData': data}" (returnChanges)="returnChangesStyle($event)"></div>

      </form>
    </section>
    <div [app-widget-edit-filters] = "{'form':composedEditForm.value, 'widgetData': data}" (returnChanges)="returnChangesFilters($event)"></div>
  </div>